import { Component, OnInit } from "@angular/core";
import { DynamicDialogRef } from "primeng/dynamicdialog";

@Component({
	selector: "app-delete-group-options",
	templateUrl: "./delete-group-options.component.html",
	styleUrls: ["./delete-group-options.component.css"],
})
export class DeleteGroupOptionsComponent implements OnInit {
	constructor(public ref: DynamicDialogRef) {}

	ngOnInit(): void {}

	///////////////////////////////////////////////////////////////////////////////////
	// Data
	///////////////////////////////////////////////////////////////////////////////////

	DeletePBIS: boolean = false;
	DeleteReleases: boolean = false;
	DeleteIncidents: boolean = false;

	///////////////////////////////////////////////////////////////////////////////////

	///////////////////////////////////////////////////////////////////////////////////
	// Buttons
	///////////////////////////////////////////////////////////////////////////////////
	onDelete() {
		var Info: any = {
			Delete: true,
			DeletePBIS: this.DeletePBIS == true ? 1 : 0,
			DeleteReleases: this.DeleteReleases == true ? 1 : 0,
			DeleteIncidents: this.DeleteIncidents == true ? 1 : 0,
		};

		this.ref.close(Info);
	}

	onClose() {
		var Info: any = {
			Delete: false,
		};

		this.ref.close(Info);
	}
	///////////////////////////////////////////////////////////////////////////////////
}
